import { combineReducers } from 'redux'


import locationUtil from './location'

import userProfile from '../Components/UserProfile/reducer'

import dialog from '../Components/DialogComponent/reducer'

import messaginScreen from '../Components/MessagingScreen/reducer'
import user from './user'

import conversations from '../Components/Conversations/reducer'

export const rootReducer = combineReducers({
  user,
  locationUtil,
  userProfile,
  messaginScreen,
  dialog,
  conversations
})


// WEBPACK FOOTER //
// ./src/reducers/index.js